var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"loading-card"},[_c('md-card-content',{staticClass:"loading-card__content"},[_c('md-progress-spinner',{staticClass:"loading-card__spinner",attrs:{"md-mode":"indeterminate"}}),_c('p',{staticClass:"loading-card__message",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }